import {
  VendorsProfile,
  AgreementsAndComplianceView,
} from '../../VendorsTabsSections';
import ActivityTracking from '../../VendorsTabsSections/ActivityTracking/ActivityTracking';
import { VendorDocuments } from '../../VendorsTabsSections/AgreementsAndCompliance';
import Offers from '../../VendorsTabsSections/Offers/Offers';
import Services from '../../VendorsTabsSections/Services/Services';

export const VendorsVerticalTabsData = [
  {
    label: 'vendors-profile',
    component: VendorsProfile,
  },
  {
    label: 'agreement',
    component: AgreementsAndComplianceView,
  },
  {
    label: 'documents',
    component: VendorDocuments,
    // permissionsList: Object.values(DevelopersPermissions),
    // permissionsId: DevelopersPermissions.Documents.permissionsId,
  },
  { label: 'activity_tracking', component: ActivityTracking },
  { label: 'services', component: Services },
  { label: 'offers', component: Offers },
];
